import styles from './style.module.css';
import imgPontosTotais from '../../../../assets/images/icon-pontos-totais.png';
import { numberWithCommas } from '../../../../utils/numberWithCommas';
import { Card } from '../../../../components/Card';
import { useAuth } from '../../../../hooks/useAuth';
import { usePoints } from '../../../../hooks/usePoints';

export function TotalPoints() {
  const { client } = useAuth();
  const { totalPoints } = usePoints();

  return (
    <div
      className={`col-sm-12 col-md-6 ${client?.settings?.redemptionPolicy ? 'col-lg-3' : 'col-lg-4'}`}
    >
      <div className="mb-3">
        <Card>
          <div className="d-flex align-items-center">
            <img
              className={`me-3 ${styles.icon}`}
              src={imgPontosTotais}
              alt="moeda"
            />
            <div className="d-block">
              <p className="m-0 tiny-text">
                {totalPoints === 1 ? (
                  <span>{`${client?.coinName ? client.coinName.replace(/\(\w*\)/g, '') : 'Ponto'}`}</span>
                ) : (
                  <span>{`${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'Pontos'}`}</span>
                )}{' '}
                Totais
              </p>
              <p className="m-0 fs-4 fw-semibold">
                {numberWithCommas(totalPoints.toFixed(2))}{' '}
                <span className="tiny-text">
                  {totalPoints === 1 ? (
                    <span>{`${client?.coinName ? client.coinName.replace(/\(\w*\)/g, '') : 'ponto'}`}</span>
                  ) : (
                    <span>{`${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}</span>
                  )}
                </span>
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
